import { Route, Routes, Navigate } from 'react-router-dom';
import Record from '@/pages/record/index';
// 旧 TextArea 版「识别词库」保留用于回退：import Keyword from '@/pages/keyword/index';
import VoiceDictionary from '@/pages/voice-dictionary/index';
import Detail from '@/pages/record/detail';
import Feedback from '@/pages/feedback/index';
// TODO: 修改为enhanced
import Account from '@/pages/account/index';
import Home from '@/pages/home/index';
import Share from '@/pages/share/index';
import ShareLink from '@/pages/sharelink/index';
import TermBase from '@/pages/termbase/index';
import TermBaseDetail from '@/pages/termbase/detail';
import { AuthProvider } from './components/AuthProvider/Provider';
import Analyse from './pages/analyse';
import GbaseAccount from './pages/gbase';
import ConnectGbase from './pages/gbase/connect';
import DesktopAuthCallback from '@/pages/desktop-auth-callback';

function RouterContainer() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/record" replace />} />
      <Route path="/desktop-auth-callback" element={<DesktopAuthCallback />} />
      <Route path="/panasonic-auth-callback" element={<DesktopAuthCallback app="panasonic" />} />
      <Route path="/share/:id/:roomId" element={<Share />} />
      <Route path="/gbase/connect" element={<ConnectGbase />} />
      <Route path="/gbase/account" element={<GbaseAccount />} />
      <Route
        path="/feedback"
        element={
          <AuthProvider>
            <Feedback />
          </AuthProvider>
        }
      />
      <Route
        path="/"
        element={
          <AuthProvider>
            <Home />
          </AuthProvider>
        }
      >
        <Route path="record" element={<Record />} />
        <Route path="keyword" element={<VoiceDictionary />} />
        <Route path="termbase" element={<TermBase />} />
        <Route path="termbase/:id" element={<TermBaseDetail />} />
        <Route path="share-link" element={<ShareLink />} />
        <Route path="record/:id" element={<Detail />} />
        <Route path="record/analyse/:subtitle_segment_id" element={<Analyse />} />
        <Route path="account" element={<Account />} />
      </Route>
      <Route path="*" element={<Navigate to="/record" replace />} />
    </Routes>
  );
}

export default RouterContainer;
